<i18n>
{
	"en": {
		"loadingMeters": "Loading",
		"volume": "Volume",
		"weight": "Gr. Weight"
	},
	"no": {
		"loadingMeters": "Lastm.",
		"volume": "Volum",
		"weight": "Br. vekt"
	}
}
</i18n>
<template>
	<div class="map-trip-selected-trip">
		<div class="map-trip-selected-trip-truck">
			<t-text color="#1a3e67" bold="true" size="12px">{{regNumber}}</t-text>
			<trip-icon :trip="trip" size="xl"/>
		</div>

		<div class="map-trip-selected-trip-truck-info">
			<div class="map-trip-selected-trip-truck-info-title">
				<t-text color="#1a3e67" bold="true" size="12px">Last</t-text>
				<t-padding left="15px">
					<t-timpex-icon
						color="blue"
						type="bp"
						icon="more"
						style="font-size: 12px; cursor: pointer;"
					/>
				</t-padding>
			</div>
			<div class="map-trip-selected-trip-truck-info-order">
				<div class="map-trip-selected-trip-truck-info-order-count">
					<t-timpex-icon color="blue" icon="order" />
					<t-text
						style="text-align: center;"
						color="#1a3e67"
						size="12px"
						bold="true"
					>{{trip.orders ? trip.orders.length : 0}}</t-text>
				</div>
				<t-metric-details
					:value="trip.volume"
					:max="getProperty(trip.cargoCarrier, 'volume')"
					:label="$t('volume')"
					decimals="1"
					unit="m3"
					size="small"
					vertical
				/>
				<t-metric-details
					:value="trip.grossWeight"
					:max="getProperty(trip.cargoCarrier, 'weight')"
					:label="$t('weight')"
					unit="kg"
					size="small"
					vertical
				/>
				<t-metric-details
					:value="trip.loadingMeters"
					:max="getProperty(trip.cargoCarrier, 'loadingMeters')"
					:label="$t('loadingMeters')"
					decimals="1"
					unit="lm"
					size="small"
					vertical
				/>
			</div>
		</div>
	</div>
</template>
<script>
import TText from './TText';
import TPadding from './TPadding';
import TripIcon from './TripIcon';
export default {
	name: 'MapTripSearchSelectedTruck',
	components: { TripIcon, TText, TPadding },
	props: { trip: { type: Object, required: true } },
	computed: {
		regNumber() {
			return this.trip && this.trip.cargoCarrier ? this.trip.cargoCarrier.registrationNumber : 'N/A';
		}
	},
	methods: {
		getProperty(object, propKey) {
			if (!object) return undefined;
			return object[propKey];
		},
	}
};
</script>
<style scoped>
.map-trip-selected-trip {
	  display: grid;
	  grid-template-columns: 140px auto;
	  column-gap: 10px;
	  padding: 0px 10px;
}
.map-trip-selected-trip-truck {
	display: grid;
	grid-template-rows: 25px auto;
	justify-items: center;
	align-items: center;
}

.map-trip-selected-trip-truck-info {
	display: grid;
	grid-template-rows: 25px auto;
	align-items: center;
}

.map-trip-selected-trip-truck-info-title {
	flex: 0.3;
	width: 100%;
	height: 15px;
}

.map-trip-selected-trip-truck-info-order {
	display: grid;
	grid-auto-flow: column;
	grid-auto-columns: max-content;
	column-gap: 10px;
}

.map-trip-selected-trip-truck-info-order-count {
	display: grid;
	grid-auto-flow: row;
	justify-content: center;
}

</style>
